export default {
  default: {
    paragraph:
      'Quotes have not been created or imported yet. Get started by clicking the button below',
  },
}
